import { Box, DraggableList, Icon, IconButton, ListItemPaper, Skeleton, Stack, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useCallback, useEffect } from "react"
import { useSortCustomArticleList } from "@tm/data/basket/customArticles/hooks/useSortCustomArticleList"
import { CompilationItem } from "./CompilationItem"
import { useOwnArticlesStore } from "../store"
import { useCompilations } from "../useCompilations"

export function CompilationList() {
    const { setCompilationToEdit, setIsExpandedCompilationsList, setSelectedCompilation, selectedCompilation } = useOwnArticlesStore()
    const { translateText } = useLocalization()
    const { mutateAsync: sortLists } = useSortCustomArticleList()

    const { compilations, hasUnlistedItems } = useCompilations()

    useEffect(() => {
        if (compilations) {
            if (selectedCompilation === undefined) {
                setSelectedCompilation(compilations[0])
            } else if (selectedCompilation && !compilations?.includes(selectedCompilation)) {
                setSelectedCompilation(compilations.find((x) => x.id === selectedCompilation.id))
            }
        }
    }, [compilations, selectedCompilation])

    function handleReorder(fromId: string, toId: string) {
        sortLists({ fromId, toId })
    }

    const handleClickAdd = useCallback(() => {
        setCompilationToEdit({
            type: "create",
            name: "",
        })
    }, [])

    return (
        <Stack width="310px" gap={0.5}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" pb={1}>
                <Typography variant="h3">{translateText(14110)}</Typography>
                <Stack direction="row" gap={0.5}>
                    <IconButton variant="contained" size="large" onClick={handleClickAdd}>
                        <Icon name="add" />
                    </IconButton>
                    <IconButton variant="contained" size="large" onClick={() => setIsExpandedCompilationsList(true)}>
                        <Icon name="arrow-right" />
                    </IconButton>
                </Stack>
            </Stack>

            {hasUnlistedItems && (
                <ListItemPaper onClick={() => setSelectedCompilation(null)} isSelected={!selectedCompilation}>
                    <Typography variant="body2" gutterBottom>
                        {translateText(14077)}
                    </Typography>
                </ListItemPaper>
            )}

            {!compilations && (
                <>
                    <Skeleton variant="rounded" width="100%" height="32px" />
                    <Skeleton variant="rounded" width="100%" height="32px" />
                    <Skeleton variant="rounded" width="100%" height="32px" />
                </>
            )}

            {compilations && (
                <Box sx={{ overflowY: "auto", padding: 1, marginInline: -1 }}>
                    <DraggableList items={compilations?.map((y) => y.id)} onReorder={handleReorder} sx={{ marginTop: -1 }}>
                        {compilations.map((compilation) => (
                            <CompilationItem
                                key={compilation.id}
                                compilation={compilation}
                                isSelected={selectedCompilation === compilation}
                                onSelect={setSelectedCompilation}
                            />
                        ))}
                    </DraggableList>
                </Box>
            )}
        </Stack>
    )
}
